import Notiflix from "notiflix";
import { useContext, useEffect, useState } from "react";
import { store } from "../../Helper/Context/Store";
import GetApiCall from "../../Helper/GetApi";
import PostApiCall from "../../Helper/PostApi";
import MainNavabar from "./MainNavabar";
import MainNavabarMenu from "./MainNavabarMenu";
import SearchBar from "./SearchBar";
import { MdShoppingCart } from "react-icons/md";
import { Dropdown } from "react-bootstrap";
import { FaUser } from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { BiSolidUser } from "react-icons/bi";
import { Link, useHistory } from "react-router-dom";
import { FaHouse } from "react-icons/fa6";
import ChangePassword from "../Login/ChangePassword";
import LoginModal from "../Login/LoginModal";
import LogoutModal from "../Login/LogoutModal";

export default function FixedNavbar() {
  const history = useHistory();
  const [scroll, setScroll] = useState(false);
  const [canLogout, setCanLogout] = useState(false);
  const [loginModalStatus, setLoginModalStatus] = useState(false);
  const [modalSide, setModalSide] = useState("");

  const [openChangePwd, setOpenChangePwd] = useState(false);
  const {
    setSiteHeader,
    setLogo,
    setClientData,
    setCartItems,
    setcart,
    setStoreStatus,
    setPinCodes,
    selectedPincode,
    setSelectedPincode,
    setShowSearchBar,
    cart,
    loggedIn,
    setLoggedIn,
    setcartamount,
  } = useContext(store);
  useEffect(() => {
    setSelectedPincode(localStorage.getItem("userPincode"));
    if (window.pageYOffset > 100) {
      setScroll("scroll");
    } else {
      window.addEventListener("scroll", () => {
        setScroll(window.scrollY > 100);
      });
    }

    if (window.pageYOffset > 100) {
      setScroll("scrollSticky");
    } else {
      window.addEventListener("scrollSticky", () => {
        setScroll(window.scrollY > 100);
      });
    }
    GetSiteSettingsV1();
    getCartdetails();
    getDeliveryPincodes();
  }, []);

  const clearItemDetails = () => {
    localStorage.removeItem("itemdetails");
  };
  const handleProfileClick = () => {
    history.push("/customer-profile");
  };
  const changePssword = () => {
    setOpenChangePwd(true);
  };

  const getDeliveryPincodes = () => {
    PostApiCall.postRequest(
      {
        WhereClause: "",
      },
      "GetWarehousePincodeMapping",
    ).then((results) =>
      results.json().then((obj) => {
        if (results.status == 200 || results.status == 201) {
          setPinCodes(obj.data);
        }
      }),
    );
  };

  const GetSiteSettingsV1 = () => {
    GetApiCall.getRequest("GetSiteSettingsV1").then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setLogo(JSON.parse(obj1.data[0].logo).logo[0].url);
          setClientData(obj1.data);
          setSiteHeader(
            JSON.parse(obj1.data[0]?.site_header)?.menu[0]?.subMenu,
          );
          setStoreStatus(obj1.data[0].storeStatus);
        }
      }),
    );
  };
  const getCartdetails = () => {
    Notiflix.Loading.circle();
    var login = localStorage.getItem("CustomerData");
    var logindetails = JSON.parse(login);
    var Order = localStorage.getItem("OrderData");
    var Orderdetails = JSON.parse(Order);
    PostApiCall.postRequest(
      {
        orderid:
          localStorage.getItem("OrderData") == null
            ? null
            : Orderdetails[0].order_id,
        id:
          localStorage.getItem("CustomerData") == null
            ? null
            : logindetails[0].fld_customerid,
      },
      "GetCartWebsite",
    )
      .then((res) => res.json())
      .then((res1) => {
        if (res1.data) {
          setCartItems(res1.data);
          Notiflix.Loading.remove();
          setcart(res1?.data.reduce((a, v) => (a = a + v.fld_quantity), 0));

          // setcartamount(res1.data[0]?.fld_cart_amount_preview);
        }
      });
  };

  const [atBottom, setAtBottom] = useState(false);

  const handleScroll = () => {
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const scrollY = window.scrollY;

    // Check if we're at the bottom (taking into account edge cases with small offsets)
    const isAtBottom = scrollY + windowHeight >= documentHeight - 1; // a small offset to prevent float point errors

    setAtBottom(isAtBottom);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleToggleModal = () => {
    setLoginModalStatus(false);
  };
  const handleChangeModalSide = (e) => {
    setModalSide(e);
  };
  // change password specific functions
  const handleTogglePwdModal = () => {
    setOpenChangePwd(false);
  };
  const handleToggleLogout = () => {
    setCanLogout(false);
  };
  const onLogout = () => {
    if (localStorage.getItem("CustomerData") !== null) {
      localStorage.removeItem("CustomerData");
      localStorage.removeItem("OrderData");
      setcart(0);
      setcartamount(0);
      setCartItems([]);
      history.push("/");
      setLoggedIn(false);
      setCanLogout(false);
      Notiflix.Loading.remove();
    } else {
      Notiflix.Notify.failure("Something went wrong");
    }
  };
  return (
    <>
      <LoginModal
        isOpen={loginModalStatus}
        handleToggleModal={handleToggleModal}
        modalSide={modalSide}
        handleChangeModalSide={handleChangeModalSide}
      />

      <ChangePassword
        isOpen={openChangePwd}
        handdleToggleModal={handleTogglePwdModal}
      />
      <LogoutModal
        show={canLogout}
        onHide={handleToggleLogout}
        onLogout={onLogout}
      />
      {/* <div
        className="text-center offer-text"
        style={{
          backgroundColor: "#faec8b",
          color: "maroon",
          fontWeight: "bold",
          paddingBottom: "5px",
          paddingTop: "5px",
        }}>
        Early bird Rakhi Offer Order before 22 August and enjoy 12% OFF on all
        Raksha Bandhan gifts.
      </div> */}
      <div
        className={`
          ${
            scroll
              ? "fixed-top fixed-nammenu fixed-navbar-top"
              : "fixed-navbar-top"
          }
            ${window.location.pathname !== "/" ? "inner-page-nav" : ""}
        `}>
        <MainNavabar />
        {/* <MainNavabarMenu /> */}
      </div>
      <SearchBar />
      <ul
        className={`main-nav-right-links contact-links d-flex d-lg-none ${
          atBottom ? "hide-nav-btn" : ""
        }`}>
        <Link to="/">
          <li className="cursor-pointer ">
            <FaHouse />
            Home
          </li>
        </Link>
        <li>
          <Dropdown className="login-dropdown d-none d-lg-flex">
            <Dropdown.Toggle
              // onClick={onProfileClick}
              className="login-icon"
              id="dropdown-basic">
              <FaUser />
              Account
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {loggedIn === false && (
                <>
                  <Dropdown.Item
                    onClick={() => {
                      setModalSide("Log");
                      setLoginModalStatus(true);
                      clearItemDetails();
                    }}>
                    Login
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setModalSide("Reg");
                      setLoginModalStatus(true);
                      clearItemDetails();
                    }}>
                    Sign Up
                  </Dropdown.Item>
                </>
              )}
              {loggedIn === true && (
                <>
                  <Dropdown.Item onClick={handleProfileClick}>
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={changePssword}>
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCanLogout(true)}>
                    Logout
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown className="login-dropdown d-flex d-lg-none">
            <Dropdown.Toggle
              // onClick={onProfileClick}
              className="login-icon"
              id="dropdown-basic">
              <BiSolidUser />
              Account
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {loggedIn === false && (
                <>
                  <Dropdown.Item
                    onClick={() => {
                      setModalSide("Log");
                      setLoginModalStatus(true);
                      clearItemDetails();
                    }}>
                    Login
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setModalSide("Reg");
                      setLoginModalStatus(true);
                      clearItemDetails();
                    }}>
                    {" "}
                    Sign Up
                  </Dropdown.Item>
                </>
              )}
              {loggedIn === true && (
                <>
                  <Dropdown.Item onClick={handleProfileClick}>
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item onClick={changePssword}>
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setCanLogout(true)}>
                    Logout
                  </Dropdown.Item>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </li>
        <Link to="/cart" className="position-relative">
          <li className="cursor-pointer me-md-2">
            <MdShoppingCart />
            Cart
            <span>{cart}</span>
          </li>
        </Link>
        <li>
          <IoSearch
            className="cursor-pointer"
            onClick={
              () => setShowSearchBar(true)
              // () => setseachBar(true)
            }
          />
          Search
        </li>
      </ul>
    </>
  );
}
